<flx-credit-note-line-items [isNonVatSP]="isNonVatSP" [actualLineItemsFormArray]="actualLineItemsFormArray" [currentState]="currentState"></flx-credit-note-line-items>

<flexus-credit-note-summary [isNonVatSP]="isNonVatSP" [editing]="true" [actualLineItemsFormArray]="actualLineItemsFormArray"></flexus-credit-note-summary>
